import { render, staticRenderFns } from "./PwdSet.vue?vue&type=template&id=2f6f9442&scoped=true"
import script from "./PwdSet.vue?vue&type=script&lang=js"
export * from "./PwdSet.vue?vue&type=script&lang=js"
import style0 from "./PwdSet.vue?vue&type=style&index=0&id=2f6f9442&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f9442",
  null
  
)

export default component.exports